import React from 'react';
import ReactDOM from 'react-dom/client';
import qs from 'qs';
import TrackLoginEvent from '../ui/track-login-event';
import LoginButtonUI from '../ui/login-button-ui';
import SocialLogins from '../ui/social-logins';
import * as LoginSignupEvents from 'tradera/legacy/static/app/ui/layout/login-signup-events';
import { EmptyStateProvider } from 'tradera/state/empty-state-provider';
import kountSdk from '@kount/kount-web-client-sdk';
import { v4 as uuidv4 } from 'uuid';
import initData from 'init-data';

const getReturnUrl = () => {
    const search = qs.parse(window.location.search, {
        ignoreQueryPrefix: true
    });

    return search['ReturnUrl'] || search['returnUrl'];
};

export default function () {
    if (initData.featureSwitches && initData.featureSwitches['kount']) {
        SetupKount();
    }

    TrackLoginEvent.attachTo(document, {
        eventType: 'login'
    });
    LoginButtonUI.attachTo('[data-login-submit]');

    if (getReturnUrl()) {
        // Delayed import of cookieUtil to avoid conflict with main module loader
        import('tradera/utils/cookie')
            .then(({ default: cookieUtil }) => {
                const cookieName = 'signup_referral_path';
                const expireDate = new Date();

                const url = new URL(getReturnUrl(), window.location.origin);
                const returnUrl = url.pathname + url.search;

                expireDate.setTime(expireDate.getTime() + 10 * 60 * 1000);
                cookieUtil.createCookie(cookieName, returnUrl, expireDate);
                return;
            })
            .catch((e) => e);
    }

    const socialLoginElement = document.getElementById('social-login');
    if (socialLoginElement) {
        const root = ReactDOM.createRoot(socialLoginElement);
        root.render(
            <EmptyStateProvider>
                <SocialLogins
                    appleClientId={socialLoginElement.getAttribute(
                        'data-apple-app-id'
                    )}
                    facebookAppId={socialLoginElement.getAttribute(
                        'data-facebook-app-id'
                    )}
                    googleAppId={socialLoginElement.getAttribute(
                        'data-google-app-id'
                    )}
                    klarnaAppId={socialLoginElement.getAttribute(
                        'data-klarna-app-id'
                    )}
                    klarnaEnvironment={socialLoginElement.getAttribute(
                        'data-klarna-environment'
                    )}
                    className=""
                    isModal={
                        socialLoginElement.getAttribute('data-is-modal') ===
                        'True'
                    }
                />
            </EmptyStateProvider>
        );
    }

    LoginSignupEvents.LoginWithPasswordButtonComponent.attachTo(
        '[data-login-submit]'
    );
}

function SetupKount() {
    const kountConfig = {
        clientID: initData.kountClientId,
        environment: initData.kountEnvironment,
        isSinglePageApp: false,
        callbacks: {
            'collect-end': (params) => {
                document
                    .getElementById('session-id')
                    .setAttribute('value', params.SessionID);
            }
        }
    };

    const sessionId = uuidv4().replace(/-/g, '');
    kountSdk(kountConfig, sessionId);
}
